module.exports = __webpack_public_path__ + "static/media/male-green-v3@2x.79822503.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/male-green-v3@2x.png
// module id = 75
// module chunks = 0